import { useEffect } from 'react';

export default function useEscape({ unless, onPress }) {
  useEffect(() => {
    function handleOnPress(e) {
      const shouldNotExecute = typeof unless === 'function' ? unless(e) : unless;

      if (shouldNotExecute || e.key !== 'Escape') {
        return;
      }

      onPress(e);
    }

    document.addEventListener('keyup', handleOnPress);

    return () => {
      document.removeEventListener('keyup', handleOnPress);
    };
  }, [unless, onPress]);
}
